import { PageId } from 'constants/pages'
import { TPageConfig } from 'models/common.model'
import { HeaderId } from 'nove8/constants/root-constants'
import { THEMES } from 'root-constants'
import { PageIdWoofzPppWoofy } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_PPP_WOOFY: Record<
  Exclude<PageIdWoofzPppWoofy, PageIdWoofzPppWoofy.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageId.DOG_AGE_WOOFZ_PPP_WOOFY]: {
    id: PageId.DOG_AGE_WOOFZ_PPP_WOOFY,
    headerId: HeaderId.LOGO_TITLE_MENU,
  },
  [PageId.DOG_OWNER_WOOFZ_PPP_WOOFY]: {
    id: PageId.DOG_OWNER_WOOFZ_PPP_WOOFY,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageId.TRAINING_COMMANDS_WOOFZ_PPP_WOOFY]: {
    id: PageId.TRAINING_COMMANDS_WOOFZ_PPP_WOOFY,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageId.URGE_WOOFZ_PPP_WOOFY]: {
    id: PageId.URGE_WOOFZ_PPP_WOOFY,
    headerId: HeaderId.BACK_MENU,
  },
  [PageId.DOG_BREED_WOOFZ_PPP_WOOFY]: {
    id: PageId.DOG_BREED_WOOFZ_PPP_WOOFY,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageId.FACING_CHALLENGES_WOOFZ_PPP_WOOFY]: {
    id: PageId.FACING_CHALLENGES_WOOFZ_PPP_WOOFY,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageId.FACING_CHALLENGES_2_WOOFZ_PPP_WOOFY]: {
    id: PageId.FACING_CHALLENGES_2_WOOFZ_PPP_WOOFY,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageId.BEHAVIOR_FREQUENCY_WOOFZ_PPP_WOOFY]: {
    id: PageId.BEHAVIOR_FREQUENCY_WOOFZ_PPP_WOOFY,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageId.URGE_PROGRAM_WOOFZ_PPP_WOOFY]: {
    id: PageId.URGE_PROGRAM_WOOFZ_PPP_WOOFY,
    headerId: HeaderId.BACK_LOGO_TITLE_MENU,
  },
  [PageId.BEHAVIOR_FEELINGS_WOOFZ_PPP_WOOFY]: {
    id: PageId.BEHAVIOR_FEELINGS_WOOFZ_PPP_WOOFY,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageId.FIX_BEHAVIOR_WOOFZ_PPP_WOOFY]: {
    id: PageId.FIX_BEHAVIOR_WOOFZ_PPP_WOOFY,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageId.URGE_4_WOOFZ_PPP_WOOFY]: {
    id: PageId.URGE_4_WOOFZ_PPP_WOOFY,
    headerId: HeaderId.BACK_LOGO_TITLE_MENU,
  },
  [PageId.COMMANDS_WOOFZ_PPP_WOOFY]: {
    id: PageId.COMMANDS_WOOFZ_PPP_WOOFY,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageId.PARENT_GOAL_WOOFZ_PPP_WOOFY]: {
    id: PageId.PARENT_GOAL_WOOFZ_PPP_WOOFY,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageId.TRAINING_PLACE_WOOFZ_PPP_WOOFY]: {
    id: PageId.TRAINING_PLACE_WOOFZ_PPP_WOOFY,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageId.TRAINING_FREQUENCY_WOOFZ_PPP_WOOFY]: {
    id: PageId.TRAINING_FREQUENCY_WOOFZ_PPP_WOOFY,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageId.URGE_5_WOOFZ_PPP_WOOFY]: {
    id: PageId.URGE_5_WOOFZ_PPP_WOOFY,
    headerId: HeaderId.BACK_LOGO_TITLE_MENU,
  },
  [PageId.PREPARE_FLOW_WOOFZ_PPP_WOOFY]: {
    id: PageId.PREPARE_FLOW_WOOFZ_PPP_WOOFY,
    headerId: HeaderId.BACK_LOGO_TITLE_MENU,
  },
  [PageId.EMAIL_WOOFZ_PPP_WOOFY]: {
    id: PageId.EMAIL_WOOFZ_PPP_WOOFY,
    headerId: HeaderId.BACK_LOGO_TITLE_MENU,
  },
  [PageId.NEWSLETTER_URGE_WOOFZ_PPP_WOOFY]: {
    id: PageId.NEWSLETTER_URGE_WOOFZ_PPP_WOOFY,
    headerId: HeaderId.BACK_LOGO_TITLE_MENU,
  },
  [PageId.LAST_CHANCE_OFFER_WOOFZ_PPP_WOOFY]: {
    id: PageId.LAST_CHANCE_OFFER_WOOFZ_PPP_WOOFY,
  },
  [PageId.SUBSCRIPTIONS_WOOFZ_PPP_WOOFY]: {
    id: PageId.SUBSCRIPTIONS_WOOFZ_PPP_WOOFY,
  },
  [PageId.CHAT_UPSELL_WOOFZ_PPP_WOOFY]: {
    id: PageId.CHAT_UPSELL_WOOFZ_PPP_WOOFY,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.CHAT_WOOFZ_PPP_WOOFY]: {
    id: PageId.CHAT_WOOFZ_PPP_WOOFY,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.ACCOUNT_WOOFY_WOOFZ_PPP_WOOFY]: {
    id: PageId.ACCOUNT_WOOFY_WOOFZ_PPP_WOOFY,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.DOWNLOAD_WOOFY_WOOFZ_PPP_WOOFY]: {
    id: PageId.DOWNLOAD_WOOFY_WOOFZ_PPP_WOOFY,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.DOWNLOAD_WOOFZ_PPP_WOOFY]: {
    id: PageId.DOWNLOAD_WOOFZ_PPP_WOOFY,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
